import React, { useContext } from 'react';
import { array } from 'prop-types';
import { useIntl } from 'react-intl';
import { formatDate } from '@tesla/intl-date-time';
import messages from '../messages';
import Title from '../Title';
import { DataContext } from '../../../containers/Search/context';
import style from './style.module.scss';
import { gioTrack, isCNDomain } from '../../../utils/common';
import { GIO_ATTRIBUTE_KEYS, GIO_EVENT_KEYS } from '../../../types';

const Table = ({ results }) => {
  const intl = useIntl();
  const api = useContext(DataContext);
  const { formatMessage, locale } = intl;

  const showDate = results && results[0] && Object.keys(results[0]).indexOf('pb') >= 0;

  const handleTitleClick = (item) => {
    if (isCNDomain()) {
      const { t: title, department, id } = item;
      gioTrack(GIO_EVENT_KEYS.CAREER_POSITION_CLICKS, {
        [GIO_ATTRIBUTE_KEYS.CAREER_PAGE_SOURCE]: document.referrer ?? '',
        [GIO_ATTRIBUTE_KEYS.CAREER_POSITION_CATEGORY]: department,
        [GIO_ATTRIBUTE_KEYS.CAREER_POSITION_ID]: id,
        [GIO_ATTRIBUTE_KEYS.CAREER_POSITION_NAME]: title,
      });
    }
  };

  return (
    <table className="tds-table tds-o-table-cells-centered tds-table--thead_border tds-table--padded_cells tds-table--hoverable tds-table--row_border tds-o-legacy-careers">
      <thead className="tds-table-head">
        <tr className="tds-table-row">
          <th role="columnheader" scope="col">
            {formatMessage(messages.Title)}
          </th>
          <th role="columnheader" scope="col">
            {formatMessage(messages.Category)}
          </th>
          <th role="columnheader" scope="col">
            {formatMessage(messages.Location)}
          </th>
          {showDate && (
            <th role="columnheader" scope="col" className={style.resultsDatePosted}>
              {formatMessage(messages.DatePosted)}
            </th>
          )}
        </tr>
      </thead>
      <tbody className="tds-table-body">
        {results &&
          results.map((item) => (
            <tr key={item.id} className="tds-table-row">
              <td>
                <Title onClick={() => handleTitleClick(item)} id={item.id} title={item.t} />
              </td>
              <td>{api.lookupDepartment(item.dp)}</td>
              <td>{api.lookupLocation(item.l)}</td>
              {showDate && <td>{formatDate(Date.parse(item.pb), { format: 'L', locale })}</td>}
            </tr>
          ))}
      </tbody>
    </table>
  );
};

Table.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  results: array.isRequired,
};

export default Table;
